require('../../modules/es6.math.hypot');
module.exports = require('../../modules/_core').Math.hypot;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/hypot.js
// module id = 299
// module chunks = 1